// ============================================
// Universele Resizer Hendel - All js
// ============================================
(function () {
    let resizeTimer;
    let lastWidth = $(window).width();
    function handleResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            let nowWidth = $(window).width();
            let crossedBreakpoint = (lastWidth >= 768 && nowWidth < 768) || (lastWidth < 768 && nowWidth >= 768);
            if (crossedBreakpoint) {
                $('.slick-initialized').each(function () {
                    $(this).slick('unslick');
                });

                setTimeout(function () {
                    initAllSliders();
                    initMobileMenuDropdown();
                    initFooterAccordion();
                }, 200);
            }

            lastWidth = nowWidth;
        }, 400);
    }

    $(window).on('resize', handleResize);


    // ============================================
    // slider Intialization
    // ============================================
   function initAllSliders() {
    let isMobile = $(window).width() < 768;

    // 1. Announcement Slider
    if ($(".announcement__items").length) {
        if ($(window).width() <= 990) {
            if ($(".announcement__items").hasClass('slick-initialized')) {
                $(".announcement__items").slick('unslick');
            }

            $(".announcement__items").slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 2500,
                speed: 500,
                arrows: false,
                dots: false,
                adaptiveHeight: false,
                pauseOnHover: false,
                pauseOnFocus: false
            });
        } else if ($(".announcement__items").hasClass('slick-initialized')) {
            $(".announcement__items").slick('unslick');
        }
    }

    // 2. Advantages Slider (Mobile Only)
    if (isMobile && $(".advantages__items").length && !$(".advantages__items").hasClass('slick-initialized')) {
        $(".advantages__items").slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 5000,
            cssEase: "linear",
            variableWidth: true,
            arrows: false,
            pauseOnHover: false,
        });
    }

    // 3. Bestsellers Slider (Mobile Only)
    if (isMobile && $('.bestsellers__items').length && !$('.bestsellers__items').hasClass('slick-initialized')) {
        $('.bestsellers__items').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
        });
    }

    // 4. Product Slider (Mobile Only)
    if ($(window).width() <= 768 && $('.product__items').length && !$('.product__items').hasClass('slick-initialized')) {
        $('.product__items').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            adaptiveHeight: true
        });
    }

    // 5. Testimonials Slider (Always)
    if ($('.testimonials__items').length && !$('.testimonials__items').hasClass('slick-initialized')) {
        $('.testimonials__items').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
        });
    }
}



    // ============================================
    // Mobile Dropdown Menu
    // ============================================
    function initMobileMenuDropdown() {
        $(".menu_dropdown .menu__nav-title").off("click");

        if ($(window).width() < 768) {
            $(".menu_dropdown .menu__nav-title").on("click", function (e) {
                e.preventDefault();
                const $content = $(this).next(".menu__nav-content");
                $(".menu__nav-content").not($content).slideUp();
                $(".menu__nav-title").not(this).removeClass("active");
                $content.slideToggle();
                $(this).toggleClass("active");
            });
        }
    }


    // ============================================
    // Footer Accordion
    // ============================================
    function initFooterAccordion() {
        $(".footer__item-title").off("click");

        if ($(window).width() < 768) {
            $(".footer__item-title.active").next(".footer__item-content").show();

            $(".footer__item-title").on("click", function (e) {
                e.preventDefault();
                const $this = $(this);
                const $content = $this.next(".footer__item-content");
                $(".footer__item-content").not($content).slideUp();
                $(".footer__item-title").not($this).removeClass("active");
                $content.slideToggle();
                $this.toggleClass("active");
            });
        } else {
            $(".footer__item-content").show();
        }
    }

// ============================================
// Start All after page load
// ============================================
$(document).ready(function () {
    initAllSliders();
    setTimeout(initAllSliders, 300);
    initMobileMenuDropdown();
    initFooterAccordion();
});

document.addEventListener('shopify:section:load', function () {
    initAllSliders();
});

document.addEventListener('shopify:section:reorder', function () {
    initAllSliders();
});

})();

// ============================================
// End All after page load
// ============================================




// ============================================
// Slider Arrow Control
// ============================================
$('.bestsellers__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.bestsellers__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});

$('.testimonials__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.testimonials__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});




// ============================================
// Scroll Animation
// ============================================
const elements = document.querySelectorAll(".scroll-animation");
function checkScroll() {
    elements.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.85) {
            el.classList.add("visible");
        }
    });
}
window.addEventListener("scroll", checkScroll);
checkScroll();




// ============================================
// Thumb Animation
// ============================================
const thumbItems = document.querySelectorAll(".thumb-animate");
function checkVisibility() {
    thumbItems.forEach(el => {
        const rect = el.getBoundingClientRect();
        const elementHeight = rect.height;
        const visibleHeight = Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top);

        if (visibleHeight >= elementHeight * 0.4) {
            el.classList.add("in-view");
        }
    });
}
window.addEventListener("scroll", checkVisibility);
checkVisibility();




// ============================================
// Reveile Animation
// ============================================
function singleScrollReveal(className = ".reveal-group", visibleOffset = 150, delay = 300) {
    function runReveal() {
        $(className).each(function () {
            var $parent = $(this);
            var windowHeight = $(window).height();
            var elementTop = $parent.offset().top - $(window).scrollTop();

            if (elementTop < windowHeight - visibleOffset) {
                $parent.children().each(function (index) {
                    var $ele = $(this);
                    setTimeout(function () {
                        $ele.addClass("insight");
                    }, index * delay);
                });
            }
        });
    }
    $(window).on("scroll", runReveal);
    $(document).ready(runReveal);
}
singleScrollReveal();




// ============================================
// Animation Class Add
// ============================================
$(document).ready(function () {
    $(".animate-left, .animate-right").addClass("show-anim");
});




// ============================================
// Header Mobile Humbeger
// ============================================
$(".header__mobi-menu").on("click", function () {
    $("body").addClass("menu-open");
});
$(".menu__close").on("click", function () {
    $("body").removeClass("menu-open");
});




// ============================================
// Header Sticky
// ============================================
function headerSticky() {
    let lastScrollTop = 0;
    const header = document.querySelector('.header');
    if (!header) return;

    window.addEventListener('scroll', function () {
        const currentScroll = window.scrollY;

        if (currentScroll > 100) {
            header.classList.add('header__inner_hove-active');
        } else {
            header.classList.remove('header__inner_hove-active');
        }

        if (currentScroll === 0) {
            header.style.transform = 'translateY(0)';
        } else if (currentScroll < lastScrollTop) {
            header.style.transform = 'translateY(0)';
        } else {
            header.style.transform = 'translateY(-100%)';
        }

        lastScrollTop = currentScroll;
    });
}
headerSticky();




// ============================================
// Filter Popup
// ============================================
$(document).on('click', '.collection__filter', function () {
    $('body').addClass('filter-open');
});

$(document).on('click', '.filtar__close, .overlay', function () {
    $('body').removeClass('filter-open');
});




// ============================================
// Filter Item Toggle
// ============================================



$('.filtar__item-content').each(function () {
    const $content = $(this);

    if ($content.hasClass('active')) {
        $content.slideDown(0);
    } else {
        $content.slideUp(0);
    }
});


$(document).on('click', '.filtar__item-title', function (e) {
    e.preventDefault();

    const $title = $(this);
    const $content = $title.next('.filtar__item-content');

    if ($content.is(':visible')) {

        $title.removeClass('active');
        $content
            .removeClass('active')
            .slideUp(300);
    } else {

        $title.addClass('active');
        $content
            .addClass('active')
            .slideDown(300);
    }
});



// ============================================
// Accordion 
// ============================================
$(".product__accordion-item .accordion__title.active").next(".accordion__content").show();

$(".product__accordion-item .accordion__title").on("click", function (e) {
    e.preventDefault();
    const $this = $(this);
    const $content = $this.next(".accordion__content");
    const $scope = $this.closest(".product__right, .product__mobi, .product__inner--rebuild");

    $scope.find(".product__accordion-item .accordion__content").not($content).hide();
    $scope.find(".product__accordion-item .accordion__title").not($this).removeClass("active");

    $content.toggle();
    $this.toggleClass("active");
});





// ============================================
// Add To Cart Loadiang
// ============================================
function handleLoading($btn, duration = 1200) {
    const $parent = $btn.parent();
    clearTimeout($parent.data("loadingTimeout"));
    $parent.addClass("loading");

    const timeoutId = setTimeout(function () {
        $parent.removeClass("loading");
    }, duration);

    $parent.data("loadingTimeout", timeoutId);
}

$(document).on("click", ".click-loading", function (e) {
    e.preventDefault();
    handleLoading($(this));
});



// ============================================
// Quantity Plus Minus
// ============================================
$(document).on("click", ".qty-plus_prod", function () {
    let $input = $(this).siblings("input");
    let value = parseInt($input.val()) || 1;
    $input.val(value + 1);
});

$(document).on("click", ".qty-minus_prod", function () {
    let $input = $(this).siblings("input");
    let value = parseInt($input.val()) || 1;

    if (value > 1) {
        $input.val(value - 1);
    }
});




// ============================================
// Product Select Dropdown
// ============================================
$(".product__select-input").on("click", function (e) {
    e.stopPropagation();
    const $wrap = $(this).closest(".product__select-input-wrap");

    $(".product__select-input-wrap").not($wrap).removeClass("select-output-show");
    $wrap.toggleClass("select-output-show");
});

$(".product__select-output-item input").on("change", function (e) {
    e.stopPropagation();
    const value = $(this).next("label").text().trim();
    const $wrap = $(this).closest(".product__select-input-wrap");

    $wrap.find(".product__select-input p").text(value);
    $wrap.removeClass("select-output-show");
});

$(document).on("click", function () {
    $(".product__select-input-wrap").removeClass("select-output-show");
});




// ============================================
// ws-login Form Tab Sign Up In
// ============================================
$(document).ready(function () {
    if ($('.ws-login__tab-btn').length && $('.ws-login__form-item').length && $('.ws-login__title h2').length) {

        function updatewsloginTitle(text) {
            $('.ws-login__title h2').text(text);
        }

        $('.ws-login__tab-btn').on('click', function () {
            var tab = $(this).data('tab');
            var titleText = $(this).text();

            $('.ws-login__tab-btn').removeClass('active');
            $(this).addClass('active');

            $('.ws-login__form-item').removeClass('active');
            $('.ws-login__form-item[data-content="' + tab + '"]').addClass('active');

            updatewsloginTitle(titleText);
        });

        $('[data-type]').on('click', function (e) {
            e.preventDefault();
            var type = $(this).data('type');
            var titleText = $('.ws-login__tab-btn[data-tab="' + type + '"]').text();

            $('.ws-login__tab-btn').removeClass('active');
            $('.ws-login__tab-btn[data-tab="' + type + '"]').addClass('active');

            $('.ws-login__form-item').removeClass('active');
            $('.ws-login__form-item[data-content="' + type + '"]').addClass('active');

            updatewsloginTitle(titleText);
            if (type === 'reset-password') {
                $('.ws-login__tab-btns').hide();
                $('.ws-login__title p').show();
                $('.ws-login__inner').addClass('ws-login__inner_pass-recover');
            } else {
                $('.ws-login__tab-btns').show();
                $('.ws-login__title p').hide();
                $('.ws-login__inner').removeClass('ws-login__inner_pass-recover');
            }
        });

        var defaultTitle = $('.ws-login__tab-btn.active').text();
        updatewsloginTitle(defaultTitle);
    }
});




// ============================================
// Input Pass Hide Show
// ============================================
$(document).ready(function () {
    $('.ws-login__pass-show').hide();

    $('.ws-login__pass-hide').on('click', function () {
        var $wrap = $(this).closest('.ws-login__pass');
        $wrap.find('input').attr('type', 'text');
        $wrap.find('.ws-login__pass-hide').hide();
        $wrap.find('.ws-login__pass-show').show();
    });

    $('.ws-login__pass-show').on('click', function () {
        var $wrap = $(this).closest('.ws-login__pass');
        $wrap.find('input').attr('type', 'password');
        $wrap.find('.ws-login__pass-show').hide();
        $wrap.find('.ws-login__pass-hide').show();
    });
});




// ============================================
// Filter Checkbox Unchecked
// ============================================
$(document).on('click', '.filtar__selected-delete', function (e) {
    e.preventDefault();
    $('.filtar').find('input[type="checkbox"]').prop('checked', false);
});




// ============================================
// Cart Drower Popup
// ============================================
$(".header__cart").on("click", function (e) {
    e.preventDefault();
    $("body").addClass("cart-drawer-open");
});

$(document).on('click', '.cart-drawer__close', function (e) {
    $("body").removeClass("cart-drawer-open");
});

$(".overlay").on("click", function () {
    $("body").removeClass("cart-drawer-open");
});



$(document).ready(function () {

  var $container = $(".cart-drawer__product-content"); // ✅ change if your scroll container is different
  var $sticky = $(".cart-drawer__checkout-btn-wrap");

  if (!$container.length || !$sticky.length) return;

  function checkStickyStatus() {
    var containerRect = $container[0].getBoundingClientRect();
    var stickyRect = $sticky[0].getBoundingClientRect();
    var isStuck = Math.abs(stickyRect.bottom - containerRect.bottom) <= 1;

    $sticky.toggleClass("cart-sticky-active", isStuck);
  }

  // Detect on scroll / resize
  $container.on("scroll", checkStickyStatus);
  $(window).on("resize", checkStickyStatus);

  // Run once initially
  checkStickyStatus();

});




$(document).on('click', '.product-description__toggle', function () {
    var $wrap = $(this).closest('.product__content');
    var $short = $wrap.find('.product-description__short');
    var $full = $wrap.find('.product-description__full');

    if ($full.is(':visible')) {
      $full.hide();
      $short.show();
      $(this).text('Read more');
    } else {
      $short.hide();
      $full.show();
      $(this).text('Read less');
    }
  });




  $('.header__search').on('click', function(e){
  e.stopPropagation();
  $(this).find('.header__search-text p').hide();
  $(this).find('.search-form').show();
  $(this).find('.search-form__input').trigger('focus');
});

$('.header__search .search-form, .header__search .search-form *').on('click', function(e){
  e.stopPropagation();
});

$(document).on('click', function(){
  $('.header__search-text .search-form').hide();
  $('.header__search-text p').show();
});

